export { default as DialogCard } from "./DialogCard";
export type { DialogCardProps } from "./DialogCardProps";
